module.exports = __webpack_public_path__ + "store/img/tag_size_small.a080bddd.svg";